module.exports = __webpack_public_path__ + "static/card-icon-dce490b23922e510fdd1b73e87665a95.png";